import { render, staticRenderFns } from "./BaseDownloadButton.vue?vue&type=template&id=173cfaee&scoped=true&"
import script from "./BaseDownloadButton.vue?vue&type=script&lang=ts&"
export * from "./BaseDownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDownloadButton.vue?vue&type=style&index=0&id=173cfaee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173cfaee",
  null
  
)

export default component.exports